import { useEffect } from 'react';
import SEO from '@/components/SEO';
import { HeroSection } from '@/components/home';

/**
 * Full-screen AI Concierge planner. Same `<HeroSection>` used on the home
 * page (which already drives the planner card + split-screen map), but
 * rendered without the surrounding marketing sections so the planner has
 * the full viewport to itself. Linked from the "Concierge Trip Planner"
 * navbar item.
 *
 * Why we reuse HeroSection instead of forking the planner: the active
 * conversation state, geocoding pipeline, and split-screen layout logic
 * all live inside `useAiSearch` + `HeroSection`. Forking would create a
 * second source of truth for the planner UI — every future fix would have
 * to be applied twice. Renting the existing component for this route
 * keeps the planner DRY at zero implementation cost.
 */
const Concierge = () => {
  useEffect(() => {
    // Hard-scroll to the top so the planner card is the first thing the
    // visitor sees. The navbar links here from any page — without this,
    // navigation from /blog or /audio-tours can land mid-scroll.
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <SEO
        title="AI Concierge — Plan your wine country trip in seconds"
        description="Tell our AI Concierge the vibe — region, mood, amenities — and get a 3-stop wine country trip plan instantly. Save, share, and refine without limits."
        path="/concierge"
      />
      <div className="bg-[#0f1424] min-h-screen">
        <HeroSection conciergeOnly />
      </div>
    </>
  );
};

export default Concierge;
